// extracted by mini-css-extract-plugin
module.exports = {"apply":"apply--2btpi","btns":"btns--2DsWS","saveBtn":"saveBtn--f_n6H","boxTitle":"boxTitle--3JHX9","info":"info--1W6Fm","high":"high--YDLsG"};